var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"element":"header-toolbar"}},[_c('div',{attrs:{"element":"header-toolbar-main"}},[_vm._t("default")],2),_c('div',{attrs:{"element":"header-toolbar-mode"}},[_vm._t("mode")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }